import { ChartMark, WidgetKind, type Report } from 'corso-admin-ui';
import {
  byFinalizedDay,
  refundOwedSoon,
  resolved,
  topProducts,
} from '../claimItems';
import { itemReturnRate } from './rate';
import { newAndRetainedRevenue } from './revenue';

const unresolvedLeftOut = 'Items with no resolution yet are left out.';

export const overview = {
  key: 'overview',
  label: 'Overview',
  dataset: 'claimItems',
  timeFields: ['createdOn'],
  widgets: [
    { kind: WidgetKind.kpi, title: 'Return requests', metric: 'claims' },
    { ...itemReturnRate, dataset: 'orderItems', timeField: 'createdOn' },
    {
      ...newAndRetainedRevenue,
      description: byFinalizedDay,
      dataset: 'claims',
      timeField: 'finalizedOn',
    },
    refundOwedSoon,
    {
      kind: WidgetKind.overTime,
      title: 'Returns over time',
      description: 'Return requests, and the items on them',
      mark: ChartMark.line,
      metrics: ['claims', 'items'],
    },
    {
      kind: WidgetKind.ranking,
      title: 'Returns by status',
      info: 'A request is counted under the status it has today.',
      dimension: 'status',
      metric: 'claims',
    },
    {
      kind: WidgetKind.ranking,
      title: 'Top reasons',
      dimension: 'reason',
      metric: 'items',
      limit: 10,
    },
    topProducts,
    {
      kind: WidgetKind.ranking,
      title: 'Resolutions',
      info: unresolvedLeftOut,
      dimension: 'resolution',
      metric: 'items',
      hideUnset: true,
    },
    {
      kind: WidgetKind.ranking,
      title: 'Item value by resolution',
      info: unresolvedLeftOut,
      dimension: 'resolution',
      metric: 'itemValue',
      hideUnset: true,
    },
    {
      kind: WidgetKind.ranking,
      title: 'Line items by resolution status',
      dimension: 'claimStatus',
      metric: 'lineItems',
      filters: resolved,
    },
    {
      kind: WidgetKind.table,
      title: 'Item value by status and requested resolution',
      description: 'Open a status to see the resolutions requested',
      dimensions: ['claimStatus', 'requestedResolution'],
      metrics: ['itemValue'],
    },
  ],
} as const satisfies Report;
